export enum ScenarioType {
  RoadTransport = 'road_transport',
  SeaTransport = 'sea_transport',
  Building = 'building',
  Solar = 'solar',
  ElectricityConsumer = 'electricity_consumer',
  ElectricitySupplier = 'electricity_supplier',
}
